export default __webpack_public_path__ + "static/media/stabilizer-hover.86812179.svg";